import { post } from "../https";

const api = "/xywapi";
// 报名服务单位获取作品
export async function getPageInstitutionWorks(data) {
  return await post(`${api}/userWorks/getPageInstitutionWorks`, data);
}
// 获取渠道注册码
export async function getChannelInfoByRegisterCode(data) {
  return await post(`${api}/userChannel/getChannelInfoByRegisterCode`, data);
}
// 报名服务单位注册
export async function registerInstitution(data) {
  return await post(`${api}/user/registerInstitution`, data);
}
// 首页获取作品
export async function getHomePageInstitutionWorks(data) {
  return await post(`${api}/userWorks/getHomePageInstitutionWorks`, data);
}
// 分页获取学生
export async function getPageUserBaby(data) {
  return await post(`${api}/userBaby/getPageUserBaby`, data);
}
